export function getTag(tags, name, type) {
    if (!tags[name]) {
        throw new Error(`Missing ${name} tag`);
    }
    if (tags[name].type !== type) {
        throw new Error(`Expected ${name} to be of type ${type}, but found ${tags[name].type}`);
    }
    return tags[name].value;
}
export function getListTag(tags, name, type, length) {
    const value = getTag(tags, name, 'list');
    if (value.type !== type) {
        throw new Error(`Expected ${name} to be a list of ${type}s, but found ${value.type}s`);
    }
    if (length && value.value.length !== length) {
        throw new Error(`Expected ${name} to be a list of length ${length}, but found length ${value.value.length}`);
    }
    return value.value;
}
export function getOptional(readResult, fallback) {
    try {
        return readResult();
    }
    catch (e) {
        return fallback;
    }
}
//# sourceMappingURL=TagUtils.js.map